var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import React from 'react';
import padStart from 'lodash/padStart';
import config from '../config';
import APInput from '../components/common/APInput';
import APNumberInput from '../components/common/APNumberInput';
import APSelect from '../components/common/APSelect';
import APDatePicker from '../components/common/APDatePicker/APDatePicker';
import APPhoneInput from '../components/common/APPhoneInput';
import APDocumentUpload from '../components/common/APDocumentUpload/APDocumentUpload';
import APImageUpload from '../components/common/APImageUpload/APImageUpload';
import APUpload from '../components/common/APUpload/APUpload';
import APTimePickerDropdown from '../components/common/APTimePickerDropdown/APTimePickerDropdown';
import APDatePickerDropdown from '../components/common/APDatePickerDropdown/APDatePickerDropdown';
import { required, email, alphanumeric, isDate, maxLength, isValidPhone, numeric } from './formValidations';
export var renderFormInputs = function renderFormInputs() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var customClass = arguments[1];
  var context = arguments[2];
  var change = arguments[3];
  var inputTypes = {
    text: renderInput,
    email: renderInput,
    number: renderNumberInput,
    select: renderSelect,
    date: renderDatePicker,
    timeDropdown: renderDatePickerDropdown,
    dateDropdown: renderTimePickerDropdown,
    phone: renderPhoneInput,
    image: renderImageUpload,
    document: renderDocumentUpload,
    country: renderCountry,
    upload: renderUpload
  };
  return fields.filter(function (field) {
    if (!inputTypes[field.type]) console.error('Unsupported ' + field.type + ' input type on field: ' + field.name);
    return inputTypes[field.type];
  }).map(function (field) {
    return inputTypes[field.type](field, customClass, context, change);
  });
};
var renderInput = function renderInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APInput, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};
var renderNumberInput = function renderNumberInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APNumberInput, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    placeholder: context.t(field.placeholder),
    validate: validators,
    info: context.t(field.info),
    customClass: customClass
  });
};
var renderSelect = function renderSelect(field, customClass, context) {
  return React.createElement(APSelect, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    customClass: customClass,
    options: Array.isArray(field.options) ? field.options.map(function (item) {
      return {
        value: item,
        label: context.t(item)
      };
    }) : Object.keys(field.options).map(function (prop) {
      return {
        value: prop,
        label: context.t(field.options[prop])
      };
    })
  });
};
var renderCountry = function renderCountry(field, customClass, context) {
  var options = config.Countries;
  var keys = Object.keys(config.Countries);
  if (field.whiteList) {
    options = keys.filter(function (country) {
      return field.whiteList.includes(options[country]);
    });
  } else if (field.blackList) {
    options = keys.filter(function (country) {
      return !field.blackList.includes(options[country]);
    });
  }
  field.options = options;
  return renderSelect(field, customClass, context);
};
var renderImageUpload = function renderImageUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return React.createElement(APImageUpload, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    alt: field.alt ? context.t(field.alt) : context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};
var renderDocumentUpload = function renderDocumentUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return React.createElement(APDocumentUpload, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    onChange: change
  });
};
var renderUpload = function renderUpload(field, customClass, context, change) {
  var validators = getInputValidators(field);
  return React.createElement(APUpload, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    customClass: customClass,
    validate: validators,
    placeholder: field.placeholder,
    maxSize: field.maxSize,
    acceptedFiles: field.acceptedFiles,
    customChange: change
  });
};
var renderDatePicker = function renderDatePicker(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APDatePicker, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date()
  });
};
var renderDatePickerDropdown = function renderDatePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APDatePickerDropdown, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    maxDate: new Date(),
    leadingZero: field.leadingZero
  });
};
var renderTimePickerDropdown = function renderTimePickerDropdown(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APTimePickerDropdown, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    type: field.type,
    info: context.t(field.info),
    validate: validators,
    customClass: customClass,
    leadingZero: field.leadingZero
  });
};
var renderPhoneInput = function renderPhoneInput(field, customClass, context) {
  var validators = getInputValidators(field);
  return React.createElement(APPhoneInput, {
    key: field.name,
    name: field.name,
    label: context.t(field.label),
    info: context.t(field.info),
    validate: validators,
    customClass: customClass
  });
};
var mapStringToValidators = {
  required: required,
  email: email,
  alphanumeric: alphanumeric,
  isDate: isDate,
  maxLength: maxLength,
  isValidPhone: isValidPhone,
  numeric: numeric
};
var getInputValidators = function getInputValidators(field) {
  if (!field.validators) return;
  var result = field.validators && field.validators.map(function (validator) {
    var _validator$split = validator.split(':'),
      _validator$split2 = _slicedToArray(_validator$split, 2),
      validatorName = _validator$split2[0],
      validatorArgs = _validator$split2[1];
    if (validatorArgs) {
      var passedArgs = validatorArgs.split(',');
      return mapStringToValidators[validatorName].apply(mapStringToValidators, _toConsumableArray(passedArgs));
    } else {
      return mapStringToValidators[validatorName];
    }
  });
  return result.filter(function (item) {
    return item;
  });
};
export var generateOptionsFromNumber = function generateOptionsFromNumber() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments[1];
  var pad = arguments[2];
  var options = [];
  for (var i = min; i < max; i++) {
    options.push(React.createElement('option', {
      key: i,
      value: i
    }, padStart(i, pad, '0')));
  }
  return options;
};
export default renderFormInputs;